export default __webpack_public_path__ + "static/media/logo_mnq.624ad599.png";